import { render, staticRenderFns } from "./tihuo.vue?vue&type=template&id=43340769&scoped=true&"
import script from "./tihuo.vue?vue&type=script&lang=js&"
export * from "./tihuo.vue?vue&type=script&lang=js&"
import style0 from "./tihuo.vue?vue&type=style&index=0&id=43340769&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43340769",
  null
  
)

export default component.exports